import { Injectable, inject } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { tests } from "./ancillaryContentOther";

@Injectable({
  providedIn: "root",
})
export class AncillaryService {
  private translate = inject(TranslateService);

  constructor() {}

  processAncillary(line: string) {
    line = line.replace("ca,", "ca.");
    const split = line.split(/,/);
    const result = split.map((part: string) => this.processLine(part.trim()));
    return result.join(", ");
  }

  processLine(line: string) {
    let result = "";

    // Remove "mit" and "with" from the start of the text
    line = line.replace(/^(mit|with)\s*/, "").trim();

    // Remove " from the start and end of the text
    line = line.replace(/^"|"$/g, "");

    line = line.replace(/(ca\.|ca|approx\.)\b/, "approx.");

    if (line.startsWith("approx.")) {
      result += this.translate.instant("ANCILLARY.approx") + " ";
      // remove "approx."
      line = line.replace(/^(approx\.)\s*/, "").trim();
    }

    line = line.replace(
      /\b(zahl|zahl\.|Zahl\.|zahlreich|zahlreiche|zahlreichen|zahlr\.)\b/g,
      "numerous"
    );

    if (line.startsWith("numerous")) {
      result += this.translate.instant("ANCILLARY.numerous" + " ");
      // remove "numerous"
      line = line.replace(/^(numerous)\s*/, "").trim();
    }

    line = line.replace(/\b(und|u\.)\b|\band\b/g, "AND");

    // Split by specific words
    let parts = line.split(/\b(AND)\b/);

    // Process each part
    parts = parts.map((part: string) => {
      let result = "";

      // Extract the number (if present) and the rest of the text
      const match = part.match(/(\d+)(.*)/);
      let restOfText = part;

      if (match) {
        const number = match[1];
        restOfText = match[2];
        result += `${number} `;
      }

      // Replace specific patterns
      const formattedText = restOfText.replace(
        /\b(schw\.-w\.|b\/w|s\/\s*w)\b/g,
        "s/w"
      );

      // Translate the text
      const translatedText = this.translate.instant(
        `ANCILLARY.[${formattedText.trim()}]`
      );

      result += translatedText;
      return result;
    });

    result += parts.join(" ");
    return result;
  }

  testFunction(): AncillaryTest[] {
    const response: AncillaryTest[] = [];

    const lines = tests;

    lines.split("\n").forEach((line: string) => {
      response.push({
        original: line,
        translated: this.processAncillary(line),
      });
    });

    return response;
  }
}

export type AncillaryTest = {
  original: string;
  translated: string;
};
